import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LinkProvider } from "@astryxdesign/core/Link";
import { InternationalizationProvider } from "@astryxdesign/core/i18n";
import ruRU from "@astryxdesign/core/locales/ru-RU.generated.js";
import { RouterLink } from "@/components/RouterLink";
import { toAppError } from "@/lib/errors";
import { useLang } from "@/lib/i18n";
import { astryxKk } from "@/lib/i18n/astryx-kk";
import { router } from "./router";

// In-memory only: nothing from the query cache is persisted to storage or the
// service worker. Owner logout calls queryClient.clear().
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, e) => count < 2 && ["network", "unknown"].includes(toAppError(e).code),
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false },
  },
});

// Astryx ships no Kazakh catalogue: our Kazakh strings on top of Russian, never English.
const ASTRYX_MESSAGES = { "ru-RU": ruRU, "kk-KZ": { ...ruRU, ...astryxKk } };

export function App() {
  const lang = useLang();
  return (
    <QueryClientProvider client={queryClient}>
      <InternationalizationProvider locale={lang === "kk" ? "kk-KZ" : "ru-RU"} messages={ASTRYX_MESSAGES}>
        <LinkProvider component={RouterLink}>
          {/* Remount on a language switch so every screen re-renders its copy; the URL keeps the place. */}
          <RouterProvider key={lang} router={router} />
        </LinkProvider>
      </InternationalizationProvider>
    </QueryClientProvider>
  );
}
